import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'

interface ConfirmDeleteDialogProps {
  show: boolean
  onClose?: () => void
  onDelete?: () => void
  isDeleting?: boolean
}

export const ConfirmDeleteDialog = (props: ConfirmDeleteDialogProps) => {
  const { show, onClose, onDelete, isDeleting } = props

  return (
    <Dialog show={show}>
      <Dialog.Header>
        <Dialog.Title>Confirmation Required</Dialog.Title>
        <Dialog.Description className="text-center">
          Are you sure you want to remove this shift?
        </Dialog.Description>
      </Dialog.Header>
      <Dialog.ClosableFooter
        className="mt-6"
        onClose={onClose}
      >
        <Button
          variant="destructive"
          onClick={onDelete}
          isLoading={isDeleting}
        >
          Remove
        </Button>
      </Dialog.ClosableFooter>
    </Dialog>
  )
}
